<mat-chip [class]="tipoStatus()">
  <div class="truncate">
    <strong class="d-inline-mobile align-bottom text-truncate" style="max-width: 220px;" [ngClass]="corTexto()">
      {{tipoTexto()}}
    </strong>
  </div>
</mat-chip>
